import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_PLAY_BOARDS_PRO_BOARD_TASK_COMPOSE_TEAM } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';

const CareerComposeTeamRedirectPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { board, task } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_PLAY_BOARDS_PRO_BOARD_TASK_COMPOSE_TEAM,
        { params: { board, task } }
      )}
      replace
    />
  );
};

export default CareerComposeTeamRedirectPage;
